import { constants } from './constants';
import { refreshRateKeys, availableRefreshRatesKeys } from './types';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("table-utility");

export const SetRefreshRateAction = actionCreator<{id: refreshRateKeys, rate: availableRefreshRatesKeys}>(constants.SET_REFRESH_RATE);
